// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportBodyHeader.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ReportBodyHeader component
 */

import React from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import Input from 'share/components/controls/Izenda.Input';

export default connect()(({ store, localization, collapseToggle }) => {
  return (
    <div className="u_table izenda-FilterHeader">
      <div className="u_tableCell u_paddingRight" onClick={collapseToggle}>
        <i className="icon-toggle-thick" />
        <strong>{localization.getText('REPORTDESIGNER_LABEL_REPORT_BODY')}</strong>
      </div>
      <div className="u_tableCell u_alignMiddle">
        <label className="checkbox-inline">
          <Input type="checkbox" checked={store.reportBody.snapToGrid} onChange={store.toggleSnapToGrid.bind(store)} />
          {localization.getText('REPORTDESIGNER_LABEL_REPORT_BODY_SNAP_MODE_CHECKBOX')}
        </label>
      </div>
    </div>
  );
});



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/Izenda.ReportBodyHeader.js